import React, { useEffect, useState } from 'react'
import './sidebar.css'
import { NavLink as Link, withRouter, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { setMobile } from '../actions/user'
import Menu from '@mui/material/Menu'
import { logout } from '../actions/user'
import { Modal, Grid } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const Sidebar = ({ history }) => {
    const location = useLocation()
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openModal, setModal] = useState(false)
    const [open, setDeleteModal] = useState(false)

    const handleDeleteModal = () => {
        setDeleteModal(!open)
    }

    const styleDeletePopup = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 366,
        borderRadius: 10,
        bgcolor: 'background.paper',
        pt: 2,
        px: 4,
        pb: 3,
    }

    useEffect(() => {
        dispatch(setMobile(false))
    }, [location.pathname])

    useEffect(() => {
        window.addEventListener(
            'resize',
            () => {
                const ismobile = window.innerWidth < 1200
                if (ismobile !== isMobile) setIsMobile(ismobile)
                if (ismobile) {
                    var sty = document.getElementsByClassName('content-wrapper')[0]
                    if (sty) sty.style.marginLeft = '0px'
                } else {
                    var sty = document.getElementsByClassName('content-wrapper')[0]
                    if (sty) sty.style.marginLeft = '239px'
                }
            },
            false,
        )
    }, [isMobile])
    useEffect(() => {
        const ismobile = window.innerWidth < 1200
        if (ismobile !== isMobile) setIsMobile(ismobile)
        if (ismobile) {
            var sty = document.getElementsByClassName('content-wrapper')[0]
            if (sty) sty.style.marginLeft = '0px'
        } else {
            var sty = document.getElementsByClassName('content-wrapper')[0]
            if (sty) sty.style.marginLeft = '239px'
        }
    }, [])

    // let arrow = document.querySelectorAll(".arrow");
    //   for (var i = 0; i < arrow.length; i++) {
    //     arrow[i].addEventListener("click", (e)=>{

    //    let arrowParent = e.target.parentElement.parentElement;//selecting main parent of arrow
    //    arrowParent.classList.toggle("showMenu");
    //     });
    //   }
    //   let sidebar = document.querySelector(".sidebar");
    //   let sidebarBtn = document.querySelector(".bx-menu");
    //   sidebarBtn.addEventListener("click", ()=>{
    //     sidebar.classList.toggle("open");
    //   });

    // const dropdown = (e) =>{

    //    let arrowParent = e.target.parentElement.parentElement;//selecting main parent of arrow
    //    arrowParent.classList.toggle("showMenu");

    // }
    const logoutUser = (token) => {
        dispatch(
            logout(token, (res) => {
                if (res) {
                    history.push('/')
                }
            }),
        )
    }

    const handleLogout = () => {
        logoutUser(user.token)
        localStorage.removeItem('reloaded');
        localStorage.removeItem('tabOpenCount');
    }

    return (
        <React.Fragment>
            <div
                className={
                    isMobile
                        ? 'sidebar close green-sidebar black-sidebar'
                        : 'sidebar  green-sidebar black-sidebar'
                }
            >
                <ul class="nav-links">

                    {user.data.roles !== "merchant" &&
                        <span class="dashboard_link_name">Dashboard</span>
                    }

                    {user && user?.data?.roles === "merchant" && <li className={location.pathname === '/merchantItems' ? 'active' : ''}>
                        <div class="iocn-link">

                            <Link activeClassName="active" exact to="/merchantItems">
                                <i class="bx">
                                    {' '}
                                    <img src={require('../assets/images/merchant icon.svg').default} />
                                </i>
                                <span class="link_name">Items</span>

                            </Link>

                        </div>
                    </li>}

                    {user && user?.data?.roles === "merchant" && <li className={location.pathname === '/redemption' ? 'active' : ''}>
                        <div class="iocn-link">
                            <Link activeClassName="active" exact to="/redemption">
                                <i class="bx">
                                    {' '}
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="#777c80de"
                                        height="1em"
                                        width="1em"
                                    >
                                        <path d="M16 2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3 6h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3M5 20H3v-7h2v7m8.97.41L7 18.5V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-2-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.25 1.58.25H19c.39 0 .74.24.9.57l-5.93 1.84z" />
                                    </svg>
                                </i>
                                <span class="link_name">Redemption</span>
                            </Link>
                        </div>
                    </li>}

                    {user && user?.data?.roles !== "merchant" && <li className={location.pathname === '/dashboard' ? 'active' : ''}>
                        <div class="iocn-link">
                            {user && user?.data?.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                <div><i class="bx">
                                    {' '}
                                    <img src={require('../assets/images/dashboardicon.svg').default} />
                                </i>
                                    <span class="link_name">Graphs</span>
                                </div>
                                :
                                <Link activeClassName="active" exact to="/dashboard">
                                    <i class="bx">
                                        {' '}
                                        <img src={require('../assets/images/dashboardicon.svg').default} />
                                    </i>
                                    <span class="link_name">Graphs</span>
                                </Link>
                            }
                        </div>
                    </li>}

                    {user && user.data.roles !== "merchant" && <li className={location.pathname === '/users' ? 'active' : ''}>
                        <div class="iocn-link">
                            {user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                <div>
                                    <i class="bx">
                                        {' '}
                                        <img
                                            height="23px"
                                            src={require('../assets/images/usersIcon.svg').default}
                                        />
                                    </i>
                                    <span class="link_name">Users</span>
                                </div>
                                :
                                <Link activeClassName="active" exact to="/users">
                                    <i class="bx">
                                        {' '}
                                        <img
                                            height="23px"
                                            src={require('../assets/images/usersIcon.svg').default}
                                        />
                                    </i>
                                    <span class="link_name">Users</span>
                                </Link>
                            }
                        </div>
                    </li>}
                    <br />
                    {user && user.data.roles !== "merchant" && <div className="hrlinesidebar" src={require('../assets/images/hr.png')} />}
                    {user && user.data.roles !== "merchant" && <br />}
                    {user && user.data.roles !== "merchant" && <span class="dashboard_link_name">CMS</span>}

                    {user && user.data.roles !== "merchant" && <li className={location.pathname === '/merchants' ? 'active' : ''}>
                        <div class="iocn-link">
                            {user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                <div>
                                    <i class="bx">
                                        {' '}
                                        <img src={require('../assets/images/merchant icon.svg').default} />
                                    </i>
                                    <span class="link_name">Merchants</span>

                                </div>
                                :
                                <Link activeClassName="active" exact to="/merchants">
                                    <i class="bx">
                                        {' '}
                                        <img src={require('../assets/images/merchant icon.svg').default} />
                                    </i>
                                    <span class="link_name">Merchants</span>

                                </Link>
                            }
                        </div>
                    </li>}

                    {user && user.data.roles !== "merchant" && <li className={location.pathname === '/featuredMerchant' ? 'active' : ''}>
                        <div class="iocn-link">
                            {user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                <div>
                                    <i class="bx">
                                        {' '}
                                        <img src={require('../assets/images/merchant icon.svg').default} />
                                    </i>
                                    <span class="link_name">Featured History</span>

                                </div>
                                :
                                <Link activeClassName="active" exact to="/featuredMerchant">
                                    <i class="bx">
                                        {' '}
                                        <img src={require('../assets/images/merchant icon.svg').default} />
                                    </i>
                                    <span class="link_name">Featured History</span>

                                </Link>
                            }
                        </div>
                    </li>}

                    {user && user.data.roles !== "merchant" && <li className={location.pathname === '/redemption' ? 'active' : ''}>
                        <div class="iocn-link">
                            <Link activeClassName="active" exact to="/redemption">
                                <i class="bx">
                                    {' '}
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="#777c80de"
                                        height="1em"
                                        width="1em"
                                    >
                                        <path d="M16 2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3 6h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3M5 20H3v-7h2v7m8.97.41L7 18.5V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-2-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.25 1.58.25H19c.39 0 .74.24.9.57l-5.93 1.84z" />
                                    </svg>
                                </i>
                                <span class="link_name">Redemption</span>
                            </Link>
                        </div>
                    </li>}
                    <br />
                    <div className="hrlinesidebar" src={require('../assets/images/hr.png')} />
                    <br />
                    <li className={location.pathname === '/settings' ? 'active' : ''}>
                        <div class="iocn-link">
                            <Link activeClassName="active" exact to="/settings">
                                <i class="bx">
                                    {' '}
                                    <img src={require('../assets/images/settings.svg').default} />{' '}
                                </i>
                                <span class="link_name">Settings</span>
                            </Link>
                        </div>
                    </li>
                    <li className={location.pathname === '/feedbacks' ? 'active' : ''}>
                        {user && user.data.roles !== "merchant" && <div class="iocn-link">
                            <Link activeClassName="active" exact to="/feedbacks">
                                <i class="bx">
                                    {' '}
                                    <img src={require('../assets/images/Feedback.svg').default} />{' '}
                                </i>
                                <span class="link_name">Feedback</span>
                            </Link>
                        </div>}
                    </li>

                    <li>
                        <a onClick={() => setDeleteModal(!open)}>
                            <i class="bx">
                                {' '}
                                <img src={require('../assets/images/log out.svg').default} />{' '}
                            </i>
                            <span class="link_name">Logout</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div>
                <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={user.is_mobile ? true : false}
                    // onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'basic-button',
                    }}
                >
                    <div className={'sidebar  green-sidebar black-sidebar'}>
                        <ul class="nav-links">
                            <span class="dashboard_link_name">Dashboard</span>

                            <li className={location.pathname === '/dashboard' ? 'active' : ''}>
                                <div class="iocn-link">
                                    {user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                        <div><i class="bx">
                                            {' '}
                                            <img src={require('../assets/images/dashboardicon.svg').default} />
                                        </i>
                                            <span class="link_name">Graphs</span>
                                        </div>
                                        :
                                        <Link activeClassName="active" exact to="/dashboard">
                                            <i class="bx">
                                                {' '}
                                                <img src={require('../assets/images/dashboardicon.svg').default} />
                                            </i>
                                            <span class="link_name">Graphs</span>
                                        </Link>
                                    }
                                </div>
                            </li>

                            <li className={location.pathname === '/users' ? 'active' : ''}>
                                <div class="iocn-link">
                                    {user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                        <div>

                                            {' '}
                                            <img
                                                height="23px"
                                                src={require('../assets/images/usersIcon.svg').default}
                                            />

                                            <span class="link_name">Users</span>
                                        </div>
                                        :
                                        <Link activeClassName="active" exact to="/users">
                                            <i class="bx">
                                                {' '}
                                                <img
                                                    height="23px"
                                                    src={require('../assets/images/usersIcon.svg').default}
                                                />
                                            </i>
                                            <span class="link_name">Users</span>
                                        </Link>
                                    }
                                </div>
                            </li>
                            <br />
                            <div
                                className="hrlinesidebar"
                                src={require('../assets/images/hr.png')}
                            />
                            <br />
                            <span class="dashboard_link_name">CMS</span>

                            <li className={location.pathname === '/merchants' ? 'active' : ''}>
                                <div class="iocn-link">
                                    {user && user.data.roles == "admin" && user.data.last_login_at == 0 && user.last_login_admin ?
                                        <div>
                                            <i class="bx">
                                                {' '}
                                                <img src={require('../assets/images/merchant icon.svg').default} />
                                            </i>
                                            <span class="link_name">Merchants</span>

                                        </div>
                                        :
                                        <Link activeClassName="active" exact to="/merchants">
                                            <i class="bx">
                                                {' '}
                                                <img src={require('../assets/images//merchant icon.svg').default} />
                                            </i>
                                            <span class="link_name">Merchants</span>

                                        </Link>
                                    }
                                </div>
                                {/* <ul class="sub-menu">
          
          <li>        
            <Link activeClassName="active" exact to="/items">
            <a> <i class='bx' ><img src={require('../assets/images/Component1.png')}/></i> Items</a>
            </Link>
            </li>
          <li>
          <Link activeClassName="active" exact to="/location">
          <a href="#"> <i class='bx' ><img src={require('../assets/images/Menu icon.png')}/></i> Location</a>
          </Link>
          </li>
          
        </ul> */}
                            </li>
                            <li className={location.pathname === '/redemption' ? 'active' : ''}>
                                <div class="iocn-link">
                                    <Link activeClassName="active" exact to="/redemption">
                                        <i class="bx">
                                            {' '}
                                            <svg
                                                viewBox="0 0 24 24"
                                                fill="#777c80de"
                                                height="1em"
                                                width="1em"
                                            >
                                                <path d="M16 2c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3m3 6h-2c0-1.2-.75-2.28-1.87-2.7L8.97 11H1v11h6v-1.44l7 1.94 8-2.5v-1c0-1.66-1.34-3-3-3M5 20H3v-7h2v7m8.97.41L7 18.5V13h1.61l5.82 2.17c.34.13.57.46.57.83 0 0-2-.05-2.3-.15l-2.38-.79-.63 1.9 2.38.79c.51.17 1.04.25 1.58.25H19c.39 0 .74.24.9.57l-5.93 1.84z" />
                                            </svg>
                                        </i>
                                        <span class="link_name">Redemption</span>
                                    </Link>
                                </div>
                            </li>
                            <br />
                            <div
                                className="hrlinesidebar"
                                src={require('../assets/images/hr.png')}
                            />
                            <br />

                            <li className={location.pathname === '/settings' ? 'active' : ''}>
                                <Link activeClassName="active" exact to="/settings">
                                    <i class="bx">
                                        {' '}
                                        <img src={require('../assets/images/settings.svg').default} />{' '}
                                    </i>
                                    <span class="link_name">Settings</span>
                                </Link>
                            </li>

                            <li className={location.pathname === '/feedbacks' ? 'active' : ''}>
                                <div class="iocn-link">
                                    <Link activeClassName="active" exact to="/feedbacks">
                                        <i class="bx">
                                            {' '}
                                            <img src={require('../assets/images/Feedback.svg').default} />{' '}
                                        </i>
                                        <span class="link_name">Feedback</span>
                                    </Link>
                                </div>
                            </li>

                            <li>
                                <a onClick={() => setDeleteModal(!open)}>
                                    <i class="bx">
                                        {' '}
                                        <img
                                            src={require('../assets/images/log out.svg').default}
                                        />{' '}
                                    </i>
                                    <span class="link_name">Logout</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </Menu>
            </div>
            <Modal
                open={open}
                onClose={handleDeleteModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleDeletePopup} className="deletePopup">
                    <div className="iconshadow">
                        <i className="  deleteIconPopup">
                            <button>
                                <img src={require('../assets/images/logout1.png')} />
                            </button>
                        </i>
                    </div>
                    <div className="textDeletePopup">
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Are you Sure?
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {user && user.data.roles === "merchant"
                                ? "Do you really want to exit the Glendale Climate Mobility Merchant Panel."
                                : "Do you really want to exit the Climate Mobility application."
                            }
                        </Typography>


                        <Typography>
                            <div className="buttonGroupDelete">
                                <button
                                    className="btn btn-primary btn-block cancelButton"
                                    onClick={() => handleDeleteModal()}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary btn-block deleteButtonUser"
                                    onClick={() => handleLogout()}
                                >
                                    <img src={require('../assets/images/logout.png')} /> Logout
                                </button>
                            </div>
                        </Typography>
                    </div>
                </Box>
            </Modal>
        </React.Fragment>
    )
}

export default withRouter(Sidebar)
